import React, { useEffect, useState } from "react";
import "./LogicalIndicatorValue.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function LogicalIndicatorValue() {
    const { logicalIndicatorValueData, isConnected } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    /* ================= DATA ================= */
    const [buyStockData, setBuyStockData] = useState([]);
    const [sellStockData, setSellStockData] = useState([]);

    useEffect(() => {
        if (!Array.isArray(logicalIndicatorValueData)) {
            setBuyStockData([]);
            setSellStockData([]);
            return;
        }

        const buyData = [];
        const sellData = [];
        console.log("Received logical indicator value data:", logicalIndicatorValueData);
        logicalIndicatorValueData.forEach((row) => {
            const signal = String(row?.signal || "").trim().toUpperCase();

            if (signal.includes("BUY")) {
                buyData.push(row);
                return;
            }

            if (signal.includes("SELL")) {
                sellData.push(row);
            }
        });
        console.log("Processed BUY stocks:", buyData);
        console.log("Processed SELL stocks:", sellData);
        setBuyStockData(buyData);
        setSellStockData(sellData);
    }, [logicalIndicatorValueData]);

    /* ================= HELPERS ================= */
    const getSignalClassName = (signal) => {
        const normalizedSignal = String(signal || "").trim().toUpperCase();

        if (normalizedSignal.includes("BUY")) return "positive";
        if (normalizedSignal.includes("SELL")) return "negative";

        return "";
    };

    const renderTableRows = (tableData, emptyMessage) => {
        if (tableData.length === 0) {
            return (
                <tr>
                    <td colSpan="10">{emptyMessage}</td>
                </tr>
            );
        }

        return tableData.map((row, idx) => (
            <tr key={`${row.symbol ?? "stock"}-${idx}`}>
                <td>{row.symbol ?? "--"}</td>
                <td>{row.ltp ?? "--"}</td>
                <td>{row.ema20 ?? "--"}</td>
                <td>{row.vwap ?? "--"}</td>
                <td>{row.pivot ?? "--"}</td>
                <td>{row.supertrend ?? "--"}</td>
                <td>{row.pdh ?? "--"}</td>
                <td>{row.pdl ?? "--"}</td>
                <td>{row.pdc ?? "--"}</td>
                <td className={getSignalClassName(row.signal)}>{row.signal ?? "--"}</td>
            </tr>
        ));
    };

    const waitingMessage = isConnected ? "No matching stocks found." : "Waiting for live data...";

    /* ================= UI ================= */

    return (
        <div className="logical-indicator-value">
                {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">

                    {/* LEFT SIDE - LOGO */}
                    <div className="left-nav">
                        <div className="logo-container">
                            <img
                                src="/assets/images/noptionwave-logo-1.png"
                                className="header-logo"
                                alt="noptionwave logo"
                            />
                        </div>
                    </div>

                    {/* RIGHT SIDE - HEADER DATA */}
                    <div className="right-nav">
                        {/* {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                <span className="header-line">
                                    {item.label1} : {item.value1}
                                </span>
                                <span className="header-line">
                                    {item.label2} : {item.value2}
                                </span>
                            </div>
                        ))} */}
                    </div>

                </nav>
            </header>
            <div className="table-container">

                {/* ================= BUY STOCKS ================= */}
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">LOGICAL BUY STOCKS</span>
                    </h2>
                </div>

                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>
                            <th>LTP</th>
                            <th>EMA20</th>
                            <th>VWAP</th>
                            <th>PIVOT</th>
                            <th>SPUER-TREND</th>
                            <th>PDH</th>
                            <th>PDL</th>
                            <th>PDC</th>
                            <th>SIGNAL</th>

                        </tr>
                    </thead>

                    <tbody>
                        {renderTableRows(
                            buyStockData,
                            Array.isArray(logicalIndicatorValueData) && logicalIndicatorValueData.length > 0
                                ? "No BUY signal stocks found."
                                : waitingMessage
                        )}
                    </tbody>
                </table>

                {/* ================= SELL STOCKS ================= */}
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">LOGICAL SELL STOCKS</span>
                    </h2>
                </div>

                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>
                            <th>LTP</th>
                            <th>EMA20</th>
                            <th>VWAP</th>
                            <th>PIVOT</th>
                            <th>SPUER-TREND</th>
                            <th>PDH</th>
                            <th>PDL</th>
                            <th>PDC</th>
                            <th>SIGNAL</th>


                        </tr>
                    </thead>
                    <tbody>
                        {renderTableRows(
                            sellStockData,
                            Array.isArray(logicalIndicatorValueData) && logicalIndicatorValueData.length > 0
                                ? "No SELL signal stocks found."
                                : waitingMessage
                        )}
                    </tbody>
                </table>



            </div>
        </div>
    );
}
